import Vue from 'vue'
import Notification from '../notification'

// URL and endpoint constants
const LOGIN_URL = 'cart/api/login/request'

export default {

  localizations: [],
  lang: null,
  validations: [],
  validationFields: [],
  errors: [],
  errorFields: [],

  localize(lang, texts) {

  },

  setLocale(lang) {
    this.lang = lang
  },

  add(field) {
    console.log('Validator.js: add():', field)
    if (!this.validationFields.includes(field.input.name)) {
      this.validations.push(field)
      this.validationFields.push(field.input.name)
    }
  },

  remove(field) {
    console.log(`Removing field ${field.input.name} from validations.`)
    for (let i = 0; i < this.validationFields.length; i++) {
      if (this.validationFields[i] == field.input.name) {
        this.validationFields.splice(i, 1)
      }
    }
    for (let i = 0; i < this.validations.length; i++) {
      if (this.validations[i].input.name == field.input.name) {
        this.validations.splice(i, 1)
      }
    }
  },

  validate(field) {
    console.log('Calling validations', field)
    if (field === undefined) {
      this.errors.splice(0)
      this.errorFields.splice(0)
    } else {
      // Remove the possible error of this field
      for (let i = 0; i < this.errors.length > 0; i++) {
        if (this.errors[i].field == field) {
          this.errors.splice(i, 1)
          console.log('Removed old error of field', field)
        }
      }
      for (let i = 0; i < this.errorFields.length > 0; i++) {
        if (this.errorFields[i] == field) {
          this.errorFields.splice(i, 1)
        }
      }
    }

    return new Promise((resolve, reject) => {
      console.log('going to validate', this.validations, field)
      this.validations.forEach(val => {
        if (field) {
          if (field == val.input.name) {
            this.performValidation(val, this.errors)
          }
        } else {
          this.performValidation(val, this.errors)
        }
      })
      this.errors.forEach(err => {
        if (!this.hasError(err.field)) {
          console.log('Added new error', err.field)
          this.errorFields.push(err.field)
        }
      })
      // console.log(this.errors)
      resolve(this.errors.length == 0)
    })
  },

  performValidation(val, errors) {
    // console.log('Running validations')
    let tests = []
    if (typeof val.test === 'object') {
      // console.log('obj', val.input.name, val.input.value, val.test)
      Object.keys(val.test).forEach(key => {
        tests.push({name: key, attr: val.test[key]})
      })
    } else {
      // console.log('pln', val.input.name, val.input.value, val.test)
      val.test.split('|').forEach(test => {
        if (test != "") {
          let parts = test.split(':')
          tests.push({name: parts[0], attr: (parts[1]) ? parts[1] : null})
        }
      })
    }

    // console.log('val.input.value', val.input.value)

    let testingValue = val.input.value
    if (typeof testingValue === 'function') {
      // console.log('validating function')
      testingValue = testingValue()
    }

    // console.log(`VALIDATE TEST ${val.input.name} [${testingValue}]`, testingValue == null, (testingValue!= null)?testingValue.length:'-', tests)
    tests.forEach(test => {
      switch (test.name) {
        case 'required': if (testingValue == null || testingValue.length == 0) {this.addError({all: val, field: val.input.name, msg: 'Field is required'})}; break
        case 'min': if (testingValue == null || testingValue.length < test.attr) {this.addError({field: val.input.name, msg: 'Field is shorter than ' + test.attr})}; break
        case 'max': if (testingValue == null || testingValue.length > test.attr) {this.addError({field: val.input.name, msg: 'Field is longer than ' + test.attr})}; break
        case 'regex': if (testingValue != null && testingValue.length > 0) {
              let re = RegExp(test.attr, 'g')
              let res = re.exec(testingValue)
              if (res == null || res[0] == "") {
                this.addError({field: val.input.name, msg: 'Field is invalid regex'})
              }
            }; break
        case 'alpha_spaces': if (testingValue != null && testingValue.length > 0) {
              let re = RegExp('[a-zA-Z0-9 .-]*', 'g')
              let res = re.exec(testingValue)
              if (res == null || res[0] == "") {
                this.addError({field: val.input.name, msg: 'Field must contain only alpha-numerical characters and spaces'})
              }
            }; break
        case 'numeric': if (testingValue != null && testingValue.length > 0) {
              let re = RegExp('^[0-9]*$', 'g')
              let res = re.exec(testingValue)
              console.log('Tested Numeric value', testingValue, re, res)
              if (res === null) {
                this.addError({field: val.input.name, msg: 'Field is invalid number'})
              }
            }; break
        case 'email': if (testingValue != null && testingValue.length > 0) {
          // console.log('VALIDATE TEST: this is email test', testingValue)
              let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              let res = re.test(testingValue)
              // console.log('VALIDATE TEST: email res', res)
              if (res == false) {
              // if (res == null || res[0] == "") {
                // console.log('VALIDATE TEST: pushing email', {field: val.input.name, msg: 'Field is invalid email'})
                this.addError({field: val.input.name, msg: 'Field is invalid'})
              }
            }; break
        case 'phone': if (testingValue != null && testingValue.length > 0) {
          // console.log('VALIDATE TEST: this is phone test', testingValue)
              let re = /^[+]?[0-9]{9,12}$|^[+]?[0-9]{3}[ \-]{1}[0-9]{3}[ \-]{1}[0-9]{3}|^[+]?[0-9]{3}[ \-]{1}[0-9]{3}[ \-]{1}[0-9]{3}[ \-]{1}[0-9]{3}$/
              let res = re.test(testingValue)
              // console.log('VALIDATE TEST: phone res', res)
              if (res == false) {
                // console.log('VALIDATE TEST: pushing phone', {field: val.input.name, msg: 'Field is invalid phone number'})
                this.addError({field: val.input.name, msg: 'Field is invalid'})
              }
            }; break
        case 'address': if (testingValue != null && testingValue.length > 0) {
              let re = RegExp('^[a-zA-Z0-9 ,.-#]*$', 'g')
              let res = re.exec(testingValue)
              if (res == null || res[0] == "") {
                console.log('This is not valid address.', testingValue)
                this.addError({field: val.input.name, msg: 'Field must contain only alpha-numerical characters and spaces'})
              }
            }; break
        default: console.error('Unknown test', test, val)
      }
    })
    // console.log('Validation result', this.errorFields, errors)
  },

  addError(err) {
    console.warn('validation error:', err)
    this.errors.push(err)
  },

  hasError(field) {
    return this.errorFields.includes(field)
  },

  first(field) {
    // console.log(field, this.errors, this.errors.filter(err => err.field == field))
    let err = this.errors.filter(err => err.field == field)
    return err.length >  0 ? err[0].msg : null
  },

}
